module.exports = __webpack_public_path__ + "static/media/nav-btn.490d6a1e.svg";